/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Tracking_CodeInputs */

const vi_carrier_tracking_code = /** @type {(inputs: Carrier_Tracking_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã vận đơn`)
};

/**

* @param {Carrier_Tracking_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_tracking_code = /** @type {((inputs?: Carrier_Tracking_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Tracking_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_tracking_code(inputs)
});